module.exports = __webpack_public_path__ + "img/chair_hot_on.3cedb2aa.png";